import React from "react";

const sahil_malawde = () => {
  return (
    <div>
      <h1>Sahil Malawde</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        CGPA must be greater than 7
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        Aptitude Test -&gt; Technical Interview 1 -&gt;Technical Interview 2 -&gt; HR
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        MCQs(Networks,OOPS,DBMS,DSA) and 2 coding questions one 20 marks and
        other 50 marks
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        23 students were shortlisted
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        Results of the interview came late night and the interviews were
        scheduled the next day. Just a quick revision of core subjects and my
        projects was all that I was able to do.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were two technical rounds followed by an HR round.
        <br />
        In the first technical round, I was asked questions on DBMS, Data
        Structures and Algorithms (DSA), and other concepts learned during my
        second year. Additionally, there were puzzles, including the classic
        sand clock puzzle, and a few questions related to my projects, mainly
        from a surface-level perspective. Out of all the participants, 14
        students were shortlisted for the next round.
      </p>

      <p>
        The second technical interview was more detailed - each of my projects
        was discussed in depth, and I was asked medium-level DSA problems that
        tested my problem-solving approach. After this round, 9 students were
        selected for the final stage.
      </p>

      <p>
        The HR interview was brief and focused primarily on understanding my
        motivation for joining the company and my career goals. In the end, 7
        students were selected for the internship.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The interview consisted of DSA questions which were medium and as of
        core subjects - DBMS was asked heavily. A question of system design was
        also there which asked how I would scale my projects. Simple puzzle was
        also there in the first technical interview
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        LeetCode - for consistent DSA practice and improving problem-solving
        speed.
      </p>

      <p>
        Apna College (YouTube) - for clear explanations of core concepts and
        interview strategies.
      </p>

      <p>
        GeeksforGeeks - to strengthen fundamentals in DBMS, OS, OOPs, and CN,
        and to practice topic-wise problems.
      </p>

      <p>
        Striver’s DSA Sheet - to follow a structured roadmap for data structures
        and algorithms.
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Try to maximize your test cases when solving problems. It’s completely
        fine to start with a brute-force or hardcoded approach at first to
        understand the logic. Once you get the correct output, work on improving
        the time and space complexity.
        <br />
        Aim to solve around 50 to 100 different types of problems on LeetCode,
        covering major DSA topics such as arrays, strings, linked lists, trees,
        recursion, dynamic programming, and graphs. This approach helps in
        building strong problem-solving skills and boosts confidence during
        interviews.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        There were many questions asked about projects and also my experience in
        CSI as a technical coordinator.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Aptitude test is the main challenge in this process overall, if you
        manage to clear the aptitude test it means that you already have a lot
        of knowledge and the further rounds would be easier. Your core subjects
        understanding and your knowledge about your projects should be 100%
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        No need to panic or get stressed out. If you have good knowledge on your
        subject you will get the internship for sure.
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Phone No :</strong> 7028990664
        <br />
        <strong>Email :</strong> <a href="mailto:msahil2806@gmail.com">msahil2806@gmail.com</a>
        <br />
        <strong>LinkedIn :</strong>
        <a href="https://www.linkedin.com/in/sahil-malawde-082704200/">
          Sahil Malawde
        </a>
      </p>
    </div>
  );
};

export default sahil_malawde;
